import { gql } from '../__generated__';

gql(/* GraphQL */ `
  fragment OperationalStatus on OperationalStatus {
    name
    id
    status
    message {
      title
      description
      link
    }
  }
`);

export const GET_OPERATIONAL_STATUS = gql(/* GraphQL */ `
  query operationalStatus($filter: OperationalStatusFilterArgs) {
    operationalStatus(filter: $filter) {
      ...OperationalStatus
    }
  }
`);
